module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-st-jude-22c3118b42997767d3d439ea5aff1659.svg";